import { MEDIA_TYPE, PROCESSING_STATUS } from 'constants/MediaConstants';

import { createDictionary } from 'utils/ObjectUtils';

import type { MediaListItem } from '../types';

export const PROCESSING_TRANSLATIONS = createDictionary(
  {
    [PROCESSING_STATUS.ERROR]: {
      id: 'page.keyDeposit.planning.card.Error',
      defaultMessage: 'Error'
    }
  },
  {
    id: 'page.fiche.medias.processing.PROCESSING',
    defaultMessage: 'In process'
  }
);

export const PROCESSING_TOOLTIP_TRANSLATIONS = createDictionary(
  {
    [PROCESSING_STATUS.ERROR]: {
      id: 'page.fiche.medias.processing.tooltip.ERROR',
      defaultMessage: 'An error has occurred while processing the media file. Please try again.'
    }
  },
  {
    id: 'page.fiche.medias.processing.tooltip.PROCESSING',
    defaultMessage: 'The media file is being processed.'
  }
);

export const sortMediasAndDocuments = (mediaList: MediaListItem[]): Record<string, MediaListItem[]> =>
  mediaList.reduce<Record<string, MediaListItem[]>>((acc, media) => {
    const isDocument = media.data.type === MEDIA_TYPE.DOCUMENT;
    // All documents are shown under the IMAGE category (translated to medias)
    const field = isDocument ? MEDIA_TYPE.DOCUMENT : MEDIA_TYPE.IMAGE;
    return {
      ...acc,
      [field]: [...(acc[field] ?? []), media]
    };
  }, { [MEDIA_TYPE.IMAGE]: [], [MEDIA_TYPE.DOCUMENT]: [] });
